export const primaryNavigation = [
  { label: "Сегодня", path: "/", icon: "today", index: "01" },
  { label: "Лиды", path: "/leads", icon: "lead", index: "02" },
  { label: "CRM", path: "/crm", icon: "crm", index: "03" },
  { label: "Проекты", path: "/projects", icon: "project", index: "04" },
];

export const secondaryNavigation = [
  { label: "Деньги", path: "/money", icon: "payment", index: "05" },
  { label: "Визитка", path: "/profile", icon: "publicProfile", index: "06" },
  { label: "Аналитика", path: "/analytics", icon: "analytics", index: "07" },
  { label: "Уведомления", path: "/notifications", icon: "notification", index: "08" },
  { label: "Настройки", path: "/settings", icon: "settings", index: "09" },
  { label: "Тариф и оплата", path: "/settings/plan", icon: "receipt", index: "10" },
];
